import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'

type PlanCapacityMS = {
  programId: string
  name: string
  trainingState: 'in_progress' | 'finished'
  trainingStart?: string
  icon?: string
  color?: string
  trainingEnd?: string
  progress?: number
  avgTtc?: number
  avgAccuracy?: number
  trainingModules: TrainingModuleMS[]
}

type TrainingModuleMS = {
  trainingModuleId: string
  title: string
  order: number
  targetTtc?: number
  targetAccuracy?: number
  avgTtc?: number
  avgAccuracy?: number
  attempts?: number
}

export function useGetList(operatorId?: string) {
  return useQuery({
    queryKey: ['mission-specialist-plan-capacity', operatorId],
    queryFn: async () => {
      const response = await apiClient.get<PlanCapacityMS[]>(
        `/int/v2/mission-specialists/${operatorId}/training-modules`
      )
      return response.data
    },
    enabled: Boolean(operatorId),
    refetchOnWindowFocus: false,
  })
}
